var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blm-number-input"},[_c('span',{staticClass:"number-control increase",class:{'invalid': _vm.invalid},on:{"click":_vm.next}},[_vm._v("+")]),_vm._v(" "),_c('span',{staticClass:"number"},[_vm._t("value",[_vm._v(_vm._s(_vm.value))],{"value":_vm.value})],2),_vm._v(" "),_c('span',{staticClass:"number-control decrease",class:{'invalid': _vm.invalid},on:{"click":_vm.previous}},[_vm._v("-")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c6925ae","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/BlmNumberInput.vue
// module id = 975
// module chunks = 0